// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAr-aN6kzFLKrFAaZ31geZDYD8zQZSM-_M",
  authDomain: "favcards-prod.firebaseapp.com",
  projectId: "favcards-prod",
  storageBucket: "favcards-prod.appspot.com",
  messagingSenderId: "540793701942",
  appId: "1:540793701942:web:058270b71292635fa43a97",
  measurementId: "G-SCRHGMQJV8",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

/**
 * Analytics is not needed to render a card, but importing it statically put the
 * SDK in the initial vendor bundle and a Google Tag Manager round-trip on the
 * critical path of every public card view. Load it once the page is idle.
 */
const loadAnalytics = () => {
  import(/* webpackChunkName: "analytics" */ "firebase/analytics")
    .then(({ getAnalytics }) => getAnalytics(app))
    .catch(() => {
      // Best-effort only — analytics must never break the page.
    });
};

const scheduleAnalytics = () => {
  if (typeof window.requestIdleCallback === "function") {
    window.requestIdleCallback(loadAnalytics, { timeout: 5000 });
  } else {
    // Safari < 16.4 has no requestIdleCallback.
    setTimeout(loadAnalytics, 3000);
  }
};

if (typeof window !== "undefined") {
  // Wait for `load` before even asking for idle time. On a fast connection the
  // browser reports idle almost immediately after first paint, which put the
  // Tag Manager fetch right back alongside the resources the card still needs.
  if (document.readyState === "complete") {
    scheduleAnalytics();
  } else {
    window.addEventListener("load", scheduleAnalytics, { once: true });
  }
}

export { auth, app };
